// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-editjobs {
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }
  
  .jobs-page-container-editjobs {
    padding: 20px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  /* Search Bar */
  .search-bar-editjobs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
    gap: 10px;
  }
  
  .search-input-editjobs{
    padding: 15px;
    width: 50%;
    border-radius: 25px;
    border: 1px solid #f7f3f3;
    font-size: 16px;
  }
  
  .search-btn-editjobs {
    padding: 15px;
    border-radius: 25px;
    border: 1px solid #1e0675;
    background-color: #f5f5f5;
    cursor: pointer;
    font-size: 18px;
  }
  
  .filter-editjobs {
  margin-right: 10px;
}

  .filters-editjobs {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    width: 100%;
    margin-bottom: 30px; 
  }
  
  .filters-editjobs select {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px;
    width: auto; 
  }
  
  /* Job Listings */
  .job-listings-editjobs {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    width: 100%;
  }
  
  .job-card-editjobs {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 12px; /* Add space between all elements inside the job card */
  }
  
  .job-card-editjobs h3 {
    margin: 0;
    font-size: 18px;
  }
  
  .job-card-editjobs .company-editjobs {
    font-size: 14px;
    color: #777;
  }
  
  .job-card-editjobs .location-editjobs,
  .job-card-editjobs .experience-editjobs {
    font-size: 12px;
    color: #555;
  }
  
  .job-card-editjobs .description-editjobs {
    font-size: 14px;
    color: #333;
  }
  
  .apply-btn-editjobs {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    margin-top: 10px;
  }
  
  .apply-btn-editjobs:hover {
    background-color: #218838;
  }
  
  .edit-btn-editjobs {
    background-color: #006b8e;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .edit-btn-editjobs:hover {
    background-color: #0056b3;
  }
  
  /* Edit Modal */
  .modal-editjobs {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content-editjobs {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    width: 400px;
  }
  
  .close-editjobs {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 30px;
        cursor: pointer;
      }
  
  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  label {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  input,
  textarea {
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  button {
    padding: 12px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  
  button:hover {
    background-color: #218838;
  }
  
  .submission-message-editjobs {
    text-align: center;
    font-size: 18px;
    color: green;
  }
  
  .submission-message-editjobs h3 {
    font-weight: bold;
    font-size: 22px;
  }
  
  .submission-message-editjobs p {
    font-size: 16px;
    color: #555;
  }

  .filters-editjobs select:first-child, 
  .filters-editjobs select:last-child {
    width: 35%; 
  }
  
  .new-job-btn-editjobs {
    background-color: #0073b1; /* LinkedIn blue */
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .new-job-btn-editjobs:hover {
    background-color: #005c8a;
  }

  .filters-container-editjobs {
    display: flex;
    gap: 20px;
    margin-right: auto;
  }

  .search-more-container-editjobs {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.search-more-btn-editjobs {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}





  `, "",{"version":3,"sources":["webpack://./src/components/EditJobs.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,eAAe;EACjB;;EAEA;EACA,kBAAkB;AACpB;;EAEE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,uDAAuD;EACpE;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,eAAe;EACf;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;QACM,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,eAAe;QACf,eAAe;MACjB;;EAEJ;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,yBAAyB,EAAE,kBAAkB;IAC7C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,SAAS;IACT,kBAAkB;EACpB;;EAEA;EACA,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".container-editjobs {\n    width: 100%;\n    max-width: 1300px;\n    margin: 0 auto;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n    background-color: #fff;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n  }\n  \n  .jobs-page-container-editjobs {\n    padding: 20px;\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  /* Search Bar */\n  .search-bar-editjobs {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    width: 100%;\n    gap: 10px;\n  }\n  \n  .search-input-editjobs{\n    padding: 15px;\n    width: 50%;\n    border-radius: 25px;\n    border: 1px solid #f7f3f3;\n    font-size: 16px;\n  }\n  \n  .search-btn-editjobs {\n    padding: 15px;\n    border-radius: 25px;\n    border: 1px solid #1e0675;\n    background-color: #f5f5f5;\n    cursor: pointer;\n    font-size: 18px;\n  }\n  \n  .filter-editjobs {\n  margin-right: 10px;\n}\n\n  .filters-editjobs {\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n    width: 100%;\n    margin-bottom: 30px; \n  }\n  \n  .filters-editjobs select {\n    padding: 8px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    font-size: 14px;\n    width: auto; \n  }\n  \n  /* Job Listings */\n  .job-listings-editjobs {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 20px;\n    width: 100%;\n  }\n  \n  .job-card-editjobs {\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    padding: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    gap: 12px; /* Add space between all elements inside the job card */\n  }\n  \n  .job-card-editjobs h3 {\n    margin: 0;\n    font-size: 18px;\n  }\n  \n  .job-card-editjobs .company-editjobs {\n    font-size: 14px;\n    color: #777;\n  }\n  \n  .job-card-editjobs .location-editjobs,\n  .job-card-editjobs .experience-editjobs {\n    font-size: 12px;\n    color: #555;\n  }\n  \n  .job-card-editjobs .description-editjobs {\n    font-size: 14px;\n    color: #333;\n  }\n  \n  .apply-btn-editjobs {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-top: 10px;\n  }\n  \n  .apply-btn-editjobs:hover {\n    background-color: #218838;\n  }\n  \n  .edit-btn-editjobs {\n    background-color: #006b8e;\n    color: white;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .edit-btn-editjobs:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Edit Modal */\n  .modal-editjobs {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .modal-content-editjobs {\n    background-color: white;\n    padding: 20px;\n    border-radius: 10px;\n    width: 400px;\n  }\n  \n  .close-editjobs {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        font-size: 30px;\n        cursor: pointer;\n      }\n  \n  form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  label {\n    font-size: 14px;\n    margin-bottom: 5px;\n  }\n  \n  input,\n  textarea {\n    padding: 10px;\n    font-size: 14px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  button {\n    padding: 12px;\n    background-color: #28a745;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n  }\n  \n  button:hover {\n    background-color: #218838;\n  }\n  \n  .submission-message-editjobs {\n    text-align: center;\n    font-size: 18px;\n    color: green;\n  }\n  \n  .submission-message-editjobs h3 {\n    font-weight: bold;\n    font-size: 22px;\n  }\n  \n  .submission-message-editjobs p {\n    font-size: 16px;\n    color: #555;\n  }\n\n  .filters-editjobs select:first-child, \n  .filters-editjobs select:last-child {\n    width: 35%; \n  }\n  \n  .new-job-btn-editjobs {\n    background-color: #0073b1; /* LinkedIn blue */\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-bottom: 20px;\n  }\n\n  .new-job-btn-editjobs:hover {\n    background-color: #005c8a;\n  }\n\n  .filters-container-editjobs {\n    display: flex;\n    gap: 20px;\n    margin-right: auto;\n  }\n\n  .search-more-container-editjobs {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.search-more-btn-editjobs {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n\n\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
